// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedTournaments_container__3Px0A","line":"FeaturedTournaments_line__1t4Aa","errorComponent":"FeaturedTournaments_errorComponent__1jQHt"};